<template>
    <div>
        <div class="view-nav">
            <div class="container-fluid p-0">
                <div class="row align-items-center">
                    <div class="col-6">Imported Session</div>
                    <div class="col-6">Imported Playlist(s)</div>
                </div>
            </div>
        </div>

        <div class="view-content container-fluid">
            <div class="row">
                <div class="col-6">
                    <div class="box">
                        <div class="box-content">
                            <heading upper="Feature title (source_title)" :lower="session.source_title" border size="sm"/>
                            <heading upper="Movix ID" :lower="session.movix_id" border size="sm"/>
                            <heading upper="Feature DCP" :lower="session.feature_dcp" border size="sm"/>
                            <heading upper="Feature UUID" :lower="session.feature_uuid" border size="sm"/>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-content">
                            <heading upper="Theatre" :lower="`${theatre.name} (${theatre.code})`" border size="sm"/>
                            <heading upper="Screen number & capacity" :lower="`${session.screen_number} (${session.screen_capacity || '0'})`" border size="sm"/>
                            <heading upper="Screen type" :lower="session.screen_type.join()" border size="sm"/>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-content">
                            <heading upper="Showtimes Session ID" :lower="session.id" border size="sm"/>
                            <heading upper="Exhibitor Session ID" :lower="session.session_exhibitor_id" border size="sm"/>
                            <heading upper="Session day" :lower="session.session_day" border size="sm"/>
                            <heading upper="Session time" :lower="`${session.session_time} (${session.session_time_zone})`" border size="sm"/>
                            <heading upper="Session week" :lower="`${lineup.week_code} (${lineup.first_day}—${lineup.last_day})`" border size="sm"/>
                            <heading upper="Session time type" :lower="session.session_time_type" border size="sm"/>
                            <heading upper="Session language (parsed, original)" :lower="`${session.session_lang} (${session.session_lang_original})`" border size="sm"/>
                            <heading upper="Session type" :lower="session.session_type" border size="sm"/>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-content">
                            <heading upper="Aspect ratio" :lower="session.content_aspect" border size="sm"/>
                            <heading upper="Dimension" :lower="session.content_dimension" border size="sm"/>
                            <heading upper="Immersive" :lower="session.content_immersive" border size="sm"/>
                        </div>
                    </div>
                    <div class="box">
                        <div class="box-content">
                            <heading upper="Source" :lower="lineup.source" border size="sm"/>
                            <heading upper="Created at" :lower="$dayjs(session.created_at).format('DD MMM YYYY HH:mm:ss')" border size="sm"/>
                            <heading upper="Updated at" :lower="session.updated_at" border size="sm"/>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <ol class="list-unstyled">
                        <li v-for="(playlist, p) in playlists" :key="p">
                            <div class="box">
                                <div class="box-content d-flex justify-content-between align-items-center" @click="() => togglePlaylistVisibility(p)">
                                    <span>
                                        <playlist-badge :status="playlist.playlist_provider_version"/>
                                        <button class="btn btn-sm btn-link">
                                            <icon :name="'chevron-' + (visible[p] ? 'up' : 'down')" />
                                        </button>
                                    </span>
                                    <span>
                                        {{ playlist.playlist_provider_id }}
                                        &emsp;
                                        <playlist-badge :status="playlist.status"/>
                                    </span>
                                </div>
                            </div>
                            <b-collapse v-model="visible[p]" accordion="my-accordion" role="tabpanel">
                                <div class="box">
                                    <div class="box-content">
                                        <heading upper="Feature title" :lower="playlist.raw.feature.title" border size="sm"/>
                                        <heading upper="Movix ID" :lower="playlist.movix_id" border size="sm"/>

                                    </div>
                                </div>
                                <div class="box">
                                    <div class="box-content">
                                        <heading upper="Theatre" :lower="playlist.theatre_code" border size="sm"/>
                                        <heading upper="Screen(s)" :lower="playlist.screens.join()" border size="sm"/>
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="box-content">
                                        <heading upper="Week" :lower="playlist.week_code" border size="sm"/>
                                        <heading upper="Validity period" :lower="`${playlist.valid_from} — ${playlist.valid_to}`" border size="sm"/>
                                        <heading upper="Timezone" :lower="playlist.time_zone" border size="sm"/>
                                    </div>
                                </div>
                                <div class="box">
                                    <div class="box-content">
                                        <heading upper="Created at" :lower="playlist.created_at" border size="sm"/>
                                        <heading upper="Updated at" :lower="playlist.updated_at" border size="sm"/>
                                    </div>
                                </div>
                            </b-collapse>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewNav from "../partials/ViewNav.vue";
import Heading from "../partials/Heading.vue";
import {BCollapse} from "bootstrap-vue";
import PlaylistBadge from "../partials/PlaylistBadge.vue";

export default {
    components: {
        BCollapse,
        Heading,
        PlaylistBadge,
        ViewNav,
    },
    props: ['week'],
    asyncData({store, route}) {
        return store.dispatch('fetchSessionWithPlaylists', route.params.id);
    },
    data() {
        const storeGetters = this.$store.getters,
            session = storeGetters.session,
            data = {
                visible: {},
                theatre: storeGetters.getTheatreByCode(session.lineup.theatre_code),
                session: storeGetters.session,
                lineup: session.lineup,
                playlists: session.playlists
                    .sort((a, b) => b.playlist_provider_version - a.playlist_provider_version),
            };

        delete session.playlists;
        delete session.lineup;

        data.session = session;

        data.playlists.forEach((playlist, p) => {
            data.visible[p] = false;
        });

        return data;
    },
    methods: {
        togglePlaylistVisibility(idx) {
            this.visible[idx] = !this.visible[idx];
        }
    }
}
</script>
